import APIClient from '@/shared/http/clients/api'

const resourceName = 'perfilconta'
const APICore = process.env.APIBaseURLCore

const GetAllByAccountId = (accountID, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/${accountID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const AccountProfileRepository = {
  GetAllByAccountId,
  Create,
  Update,
  Delete
}

export default AccountProfileRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/accountprofile.js